import { useEffect } from 'react'
import { batch, useDispatch, useSelector } from 'react-redux'
import { ConfirmModal } from 'components/dialog/ModalTemplate'
import classNames from 'classnames'
import { Modal } from 'components/dialog/Modals'
import NoneAnchor from 'components/NoneAnchor'
import {
  clearId,
  fetchKakaoServices,
  hideKakaoServices,
  linkKakaoServices,
  setTab,
} from 'features/crux/tracker/modal/kakaoService/kakaoServiceTrackSlice'
import PlusFriends from 'features/crux/tracker/modal/kakaoService/list/PlusFriends'
import ServiceItems from 'features/crux/tracker/modal/kakaoService/list/ServiceItems'
import { KAKAO_SERVICE } from 'features/crux/tracker/modal/kakaoService/KakaoServiceCodes'
import { fail } from 'features/toast/Toast'
import { resetCreateTrack } from 'features/crux/tracker/modal/create/createTrackSlice'
import { fetchLinkedTracks } from 'features/crux/tracker/list/trackerListSlice'

const KakaoServiceTrack = () => {
  const dispatch = useDispatch()
  const { visible, tab, isLoading, isSubmitting, selected } = useSelector(
    state => state.tracker.kakaoServiceTrack
  )
  const isEmpty =
    selected[KAKAO_SERVICE.plusfriend.name].length === 0 &&
    selected[KAKAO_SERVICE.talkstore.name].length === 0 &&
    selected[KAKAO_SERVICE.gift.name].length === 0

  useEffect(() => {
    if (visible) {
      dispatch(fetchKakaoServices())
    }
  }, [dispatch, tab, visible])

  const handleClose = () => {
    dispatch(hideKakaoServices())
  }
  const handleConfirm = async () => {
    const { error, payload } = await dispatch(linkKakaoServices())
    if (error) {
      fail(payload?.message || '알 수 없는 에러가 발생했습니다.')
    } else {
      batch(() => {
        dispatch(hideKakaoServices())
        dispatch(resetCreateTrack())
        if (tab !== 'linked') {
          setTab('linked')
        }
        dispatch(fetchLinkedTracks())
      })
    }
  }

  return (
    <Modal className="pixelkakakao_layer" on={visible}>
      <ConfirmModal
        title="카카오 서비스 연동"
        handleClose={handleClose}
        onConfirm={handleConfirm}
        confirmText="저장"
        confirmDisabled={isEmpty || isSubmitting}
        footer={
          <>
            <span className="wrap_delbtn">
              {selected[KAKAO_SERVICE.plusfriend.name].length > 0 && (
                <NoneAnchor
                  className="btn_gm gm_round"
                  onClick={() =>
                    dispatch(clearId(KAKAO_SERVICE.plusfriend.name))
                  }>
                  <span className="inner_g">
                    {KAKAO_SERVICE.plusfriend.text}{' '}
                    <em className="fc_emph">
                      {selected[KAKAO_SERVICE.plusfriend.name].length}
                    </em>
                  </span>
                  <span className="ico_comm ico_del">삭제</span>
                </NoneAnchor>
              )}
              {selected[KAKAO_SERVICE.talkstore.name].length > 0 && (
                <NoneAnchor
                  className="btn_gm gm_round"
                  onClick={() =>
                    dispatch(clearId(KAKAO_SERVICE.talkstore.name))
                  }>
                  <span className="inner_g">
                    {KAKAO_SERVICE.talkstore.text}{' '}
                    <em className="fc_emph">
                      {selected[KAKAO_SERVICE.talkstore.name].length}
                    </em>
                  </span>
                  <span className="ico_comm ico_del">삭제</span>
                </NoneAnchor>
              )}
              {selected[KAKAO_SERVICE.gift.name].length > 0 && (
                <NoneAnchor
                  className="btn_gm gm_round"
                  onClick={() => dispatch(clearId(KAKAO_SERVICE.gift.name))}>
                  <span className="inner_g">
                    {KAKAO_SERVICE.gift.text}{' '}
                    <em className="fc_emph">
                      {selected[KAKAO_SERVICE.gift.name].length}
                    </em>
                  </span>
                  <span className="ico_comm ico_del">삭제</span>
                </NoneAnchor>
              )}
            </span>
          </>
        }>
        <strong className="layer_subtit">
          대상 픽셀 &amp; SDK :{' '}
          <span className="fw_normal">
            죠르디 스마트 스토어 <em className="fc_gray">1234567890</em>
          </span>
        </strong>
        <div className="box_card">
          <ul className="tab_g" role="tablist">
            <li
              role="presentation"
              className={classNames({
                on: tab === KAKAO_SERVICE.plusfriend.name,
              })}>
              <NoneAnchor
                role="tab"
                className="link_tab"
                onClick={() => {
                  if (!isLoading) {
                    dispatch(setTab(KAKAO_SERVICE.plusfriend.name))
                  }
                }}>
                <span className="inner_tab">
                  <span className="inner_txt">
                    {KAKAO_SERVICE.plusfriend.text}
                  </span>
                </span>
              </NoneAnchor>
            </li>
            <li
              role="presentation"
              className={classNames({
                on: tab === KAKAO_SERVICE.talkstore.name,
              })}>
              <NoneAnchor
                role="tab"
                className="link_tab"
                onClick={() => {
                  if (!isLoading) {
                    dispatch(setTab(KAKAO_SERVICE.talkstore.name))
                  }
                }}>
                <span className="inner_tab">
                  <span className="inner_txt">
                    {KAKAO_SERVICE.talkstore.text}
                  </span>
                </span>
              </NoneAnchor>
            </li>
            <li
              role="presentation"
              className={classNames({ on: tab === KAKAO_SERVICE.gift.name })}>
              <NoneAnchor
                role="tab"
                className="link_tab"
                onClick={() => {
                  if (!isLoading) {
                    dispatch(setTab(KAKAO_SERVICE.gift.name))
                  }
                }}>
                <span className="inner_tab">
                  <span className="inner_txt">{KAKAO_SERVICE.gift.text}</span>
                </span>
              </NoneAnchor>
            </li>
          </ul>
          <div className="tab_cont">
            <div className="tbl_top">
              <ul className="list_guide">
                <li>
                  마스터/매니저 권한을 가진 서비스 목록입니다. 픽셀&amp;SDK와
                  연동할 서비스를 선택하세요.
                </li>
                <li>
                  이미 타 픽셀&amp;SDK와 연동된 서비스를 선택할 경우, 기존
                  픽셀&amp;SDK와 서비스의 연동은 해제됩니다.
                </li>
              </ul>
            </div>
            {tab === KAKAO_SERVICE.plusfriend.name ? (
              <PlusFriends />
            ) : (
              <ServiceItems />
            )}
          </div>
        </div>
      </ConfirmModal>
    </Modal>
  )
}
export default KakaoServiceTrack
